<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
  export default {
    name: 'App',
    data(){
      return {
      }
    }
  }
</script>
<style lang="scss">
 
html, body {
  height: 100%;
  margin: 0;
  font-family: myFont;
  padding: 0;
  letter-spacing: 1px;
}
#app {
   font-family:myFont;
       letter-spacing: 1px;
  // font-family: Avenir, Helvetica, Arial, sans-serif;
  // -webkit-font-smoothing: antialiased;
  // -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2d343b;
  height: 100%;
}
</style>
